<template>
    <div class="table-pagination" v-if="links.length > 3">
        <div class="flex items-center justify-between">
            <div class="buttons">
                <template v-for="(link, k) in links" :key="k">
                    <div v-if="link.url === null"
                         class="button"
                         v-html="link.label"/>
                    <a v-else type="button" class="button" :class="{'active': link.active}" :href="link.url" v-html="link.label"></a>
                </template>
            </div>
            <small>Page {{activePage}} of {{totalPages}}</small>
        </div>
    </div>
</template>

<script>
export default {
    name: "Pagination",
    props: {
        links: Array,
        activePage: String,
        totalPages: String
    }
}
</script>

<style scoped>

</style>
